var __vue_script__, __vue_template__
require("!!vue-style-loader!css-loader!./../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-0a462969&scoped=true!sass?indentedSyntax!./../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!./Background.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!./../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!./Background.vue")
__vue_template__ = require("!!vue-html-loader!./../../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-0a462969!./../../../node_modules/vue-loader/lib/template-loader.js?raw&engine=jade!./../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./Background.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}



/*****************
 ** WEBPACK FOOTER
 ** ./public/_src/_vue/Background.vue
 ** module id = 17
 ** module chunks = 0
 **/